import { Box, Button, FormTextField, FormTextFieldProps } from '@razz-team/ui-web';
import { differenceInSeconds } from 'date-fns';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface OtpFieldProps extends FormTextFieldProps {
  resendAllowedAt?: Date | number | string | undefined | null;
  onResend?: () => void;
}

function filter(value: string) {
  return /^\d{0,6}$/.test(value);
}

export function OtpField({ resendAllowedAt, onResend, helperText, ...props }: OtpFieldProps) {
  const { t } = useTranslation();
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    if (typeof resendAllowedAt !== 'undefined' && resendAllowedAt !== null) {
      setTimer(Math.max(0, differenceInSeconds(resendAllowedAt, new Date())));
    }
  }, [resendAllowedAt]);

  useEffect(() => {
    if (timer > 0) {
      const interval = setTimeout(() => {
        setTimer((prev) => Math.max(0, prev - 1));
      }, 1000);

      return () => clearTimeout(interval);
    }
  }, [timer, resendAllowedAt]);

  return (
    <>
      <FormTextField
        helperText={helperText}
        type="text"
        filter={filter}
        maxLength={6}
        inputMode="numeric"
        inputProps={{
          'data-1p-ignore': true,
          autoComplete: 'one-time-code',
          maxLength: 6,
          minLength: 6,
          inputMode: 'numeric',
          pattern: '\\d{6}',
        }}
        {...props}
      />
      {onResend ? (
        <Box>
          <Button variant="text" disabled={timer > 0} color="info" onClick={onResend}>
            {timer > 0 ? t('Resend in {{timer}} sec', { timer }) : t('Resend')}
          </Button>
        </Box>
      ) : null}
    </>
  );
}
